import React from 'react';

import { BASE_COLOR as BC, FEEDBACK_COLOR } from 'shared/constants/colors';

import { Note, FontIcon } from 'components/elems';


/*
 * Helpers for using Note
 */
export const renderNote = (type, message, attrs = {}) => {
  const {title = null, withIcon = false, style = {}} = attrs;
  if (!message && !title) {
    return null;
  }

  const icontype = {
    success: 'smile',
    info: 'infocircleo',
    warning: 'exclamationcircleo',
    error: 'frown',
  }[type] || null;

  const icon = (withIcon && icontype
    ? <FontIcon type={icontype} style={{fontSize: '32px', opacity: 0.6}} />
    : null
  );

  const color = FEEDBACK_COLOR[type];

  return (
    <Note
      icon={icon}
      title={title}
      color={color}
      style={{ background: BC.paperWhite, ...style }}
    >
      <div className='lh-copy'>
        {message}
      </div>
    </Note>
  );
};

export const note = {
  meh:     (message, attrs) => renderNote('meh', message, attrs),
  success: (message, attrs) => renderNote('success', message, attrs),
  info:    (message, attrs) => renderNote('info', message, attrs),
  warning: (message, attrs) => renderNote('warning', message, attrs),
  error:   (message, attrs) => renderNote('error', message, attrs),
};



// WEBPACK FOOTER //
// ./src/presets/note.js